import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AssessmentCard, LessonCard } from "src/pages/coaching/components/contents/card";
import CircularProgress from "src/pages/coaching/components/progress";
import { LearningRecordCourse } from "src/types/coaching/learners";

import _ from "lodash";
import cx from "classnames";

import { Assessment } from "src/types/coaching/courses";

import styles from "./cards.module.scss";
import { CourseContext } from "../context";

interface LessonRowProps {
  course: LearningRecordCourse;
  lesson: any;
  index: number;
  lessonIndex: number;
  active: boolean;
  className?: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (index: number) => void;
}

export const LessonRow: React.FC<LessonRowProps> = ({ className, course, lesson, lessonIndex, index, active, onClick }) => {
  
  const percentCompleted = useMemo(() => {
    const sessions = course.sessions || [];
    const item = sessions?.find((item) => item.id === lesson.id && item.type === 'lesson');
    return item?.percentCompleted || 0;
  }, [course]);

  return (
    <LessonCard key={index}
      className={className}
      lessonIndex={lessonIndex}
      lesson={lesson}
      index={index}
      active={active}
      readonly
      onClick={onClick}
    >
      {percentCompleted > 0 && percentCompleted < 100 && (
        <div className={styles.action}>
          <CircularProgress progress={percentCompleted} />
        </div>
      )}
      {percentCompleted === 0 && (
        <button className={styles.action}>
          <i className="paperflite-play"></i>
        </button>
      )}

      {percentCompleted === 100 && (
        <div className={cx(styles.action, styles.completed)}>
          <i className="paperflite-tick-unselected"></i>
        </div>
      )}
    </LessonCard>
  );
};

interface AssessmentRowProps {
  course: LearningRecordCourse;
  assessment: Assessment;
  index: number;
  active: boolean;
  className?: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (index: number) => void;
}

export const AssessmentRow: React.FC<AssessmentRowProps> = ({ className, course, assessment, index, active, onClick }) => {

  const { percentCompleted, completed } = useMemo(() => {
    const sessions = course.sessions || [];
    const item = sessions?.find((item) => item.id === assessment.id && item.type === 'assessment');
    return {
      percentCompleted: (item?.percentCompleted || 0) * 100,
      completed: item?.status === 'COMPLETED',
    }
  }, [course]);


  return (
    <AssessmentCard key={index}
      className={className}
      assessment={assessment}
      index={index}
      active={active}
      readonly
      onClick={onClick}
    >

      {!completed && percentCompleted > 0 && (
        <div className={styles.action}>
          <CircularProgress progress={percentCompleted} />
        </div>
      )}

      {!completed && percentCompleted == 0 && (
        <button className={styles.action}>
          <i className="paperflite-play"></i>
        </button>
      )}

      {completed && (
        <div className={cx(styles.action, styles.completed)}>
          <i className="paperflite-tick-unselected"></i>
        </div>
      )}
    </AssessmentCard>
  );
};